import { render } from "./BaseViewToggle.vue?vue&type=template&id=b958c052&scoped=true"
import script from "./BaseViewToggle.vue?vue&type=script&lang=js"
export * from "./BaseViewToggle.vue?vue&type=script&lang=js"

import "./BaseViewToggle.vue?vue&type=style&index=0&id=b958c052&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b958c052"]])

export default __exports__